import React from 'react';
import { StyleSheet, Text, TextStyle, View } from 'react-native';

import { fetchModule } from '../api/Modules';
import { IconName } from '../style/IconsRegular';
import Style from '../style';

interface MTProps {
  moduleId: string;
  style: TextStyle;
  icon?: IconName,
  iconStyle?: {
    color?: string,
    size?: number,
  },
}

const ModuleTitle = (props: MTProps) => {
  const { moduleId, style, icon, iconStyle } = props;
  const { data: module, error } = fetchModule(moduleId).swr;
  let title = module ? module.name : '';
  if (error || (module && 'httpStatus' in module)) title = moduleId;

  return (
    <View style={styles.container}>
      <Text numberOfLines={1} style={[styles.title, style]}>{title}</Text>
      {icon
        && (
          <Style.Icon.ByName
            name={icon}
            width={iconStyle?.size || 20}
            height={iconStyle?.size || 20}
            fill={iconStyle?.color || Style.Color.Black}
          />
        )}
    </View>
  );
};

export default ModuleTitle;

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  title: {
    marginRight: 6,
  },
});
